import { useContext } from "react";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
	Box,
	IconButton,
	ToggleButton,
	Tooltip,
	alpha,
	lighten,
	styled,
	useTheme,
} from "@mui/material";
import { useNavigate } from "react-router";
import { SidebarContext } from "src/components/Context/SidebarContext";
import NotificationManagement from "src/common/Notification/NotificationManagement";
import HeaderUserbox from "./Userbox";
import FairSelect from "src/common/fairSelect/FairSelect";

const HeaderWrapper = styled(Box)(
	({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 1.5)};
        right: 0;
        z-index: 1200;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(8px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
            padding: ${theme.spacing(0, 2)};
        }
`
);

function Header() {
	const { toggleSidebar } = useContext(SidebarContext);
	const theme = useTheme();
	const navigate = useNavigate();

	return (
		<HeaderWrapper
			display='flex'
			alignItems='center'
			sx={{
				boxShadow:
					theme.palette.mode === "dark"
						? `0 1px 0 ${alpha(
								lighten(theme.colors.primary.main, 0.7),
								0.15
						  )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
						: `0px 2px 8px -3px ${alpha(
								theme.colors.alpha.black[100],
								0.12
						  )}, 0px 5px 22px -4px ${alpha(
								theme.colors.alpha.black[100],
								0.06
						  )}`,
			}}
		>
			{/* Left Side: Mobile Hamburger OR Desktop Back/Forward Nav */}
			<Box display='flex' alignItems='center' gap={1}>
				{/* Mobile Hamburger Menu Icon */}
				<Box
					sx={{
						display: { xs: "flex", lg: "none" },
						alignItems: "center",
					}}
				>
					<Tooltip arrow title='Toggle Menu'>
						<IconButton
							color='primary'
							onClick={toggleSidebar}
							sx={{
								p: 0.8,
								bgcolor: alpha(theme.palette.primary.main, 0.08),
								"&:hover": {
									bgcolor: alpha(theme.palette.primary.main, 0.16),
								},
								borderRadius: 1.5,
							}}
						>
							<MenuTwoToneIcon fontSize='medium' />
						</IconButton>
					</Tooltip>
				</Box>

				{/* Desktop Back / Forward Buttons */}
				<Box
					sx={{
						display: { xs: "none", md: "flex" },
						alignItems: "center",
						gap: 0.8,
					}}
				>
					<ToggleButton
						onClick={() => navigate(-1)}
						value='back'
						size='small'
						sx={{ p: 0.6, borderRadius: 1 }}
					>
						<ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
					</ToggleButton>
					<ToggleButton
						onClick={() => navigate(1)}
						value='forward'
						size='small'
						sx={{ p: 0.6, borderRadius: 1 }}
					>
						<ArrowForwardIosIcon sx={{ fontSize: 16 }} />
					</ToggleButton>
				</Box>
			</Box>

			{/* Right Side: Fair Select + Notifications + Userbox */}
			<Box display='flex' alignItems='center' gap={{ xs: 1, sm: 1.5 }}>
				<Box
					sx={{
						width: { xs: 180, sm: 260, md: 340, lg: 400 },
						maxWidth: "100%",
						transition: "width 0.2s",
					}}
				>
					<FairSelect />
				</Box>

				<NotificationManagement />

				<HeaderUserbox />
			</Box>
		</HeaderWrapper>
	);
}

export default Header;
